var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        { ref: "form", attrs: { "lazy-validation": "" } },
        [
          _vm.tenant === "alliance-retail-group"
            ? _c(
                "v-row",
                { staticClass: "promoRow" },
                [
                  _c(
                    "v-col",
                    { staticClass: "px-1", attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.brand,
                          label: "Brand",
                          disabled:
                            _vm.readOnlyPromo && !_vm.promoNameEditException,
                          "background-color": "#fff",
                          dense: "",
                          rules: [
                            _vm.validateRequired,
                            _vm.validatePromoNameField
                          ],
                          autocomplete: "off",
                          outlined: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.$emit("update:brand", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-1", attrs: { cols: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.description,
                          label: "Product Description",
                          disabled:
                            _vm.readOnlyPromo && !_vm.promoNameEditException,
                          "background-color": "#fff",
                          dense: "",
                          rules: [
                            _vm.validateRequired,
                            _vm.validatePromoNameField
                          ],
                          maxlength: "70",
                          autocomplete: "off",
                          outlined: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.$emit("update:description", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isVendorAccrualPromo
                    ? _c(
                        "v-col",
                        { staticClass: "px-1", attrs: { cols: "2" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.packageSize,
                              label: "Package Size",
                              disabled:
                                _vm.readOnlyPromo &&
                                !_vm.promoNameEditException,
                              "background-color": "#fff",
                              dense: "",
                              rules: [
                                _vm.validateRequired,
                                _vm.validatePromoNameField
                              ],
                              maxlength: "20",
                              autocomplete: "off",
                              outlined: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.$emit("update:packageSize", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isVendorAccrualPromo,
                          expression: "!isVendorAccrualPromo"
                        }
                      ],
                      staticClass: "px-1",
                      attrs: { cols: "1" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.netUnitCost,
                          label: "Net Unit Cost",
                          type: "number",
                          min: "0",
                          step: ".01",
                          prefix: "$",
                          disabled:
                            _vm.readOnlyPromo && !_vm.promoNameEditException,
                          "background-color": "#fff",
                          dense: "",
                          autocomplete: "off",
                          outlined: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.$emit("update:netUnitCost", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-1" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.specialNote,
                          label: "Special Note",
                          disabled:
                            _vm.readOnlyPromo && !_vm.promoNameEditException,
                          placeholder: "(store exclusions, alliance link, etc)",
                          maxlength: "110",
                          "background-color": "#fff",
                          rules: [_vm.validatePromoNameField],
                          dense: "",
                          autocomplete: "off",
                          outlined: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.$emit("update:specialNote", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            { staticClass: "promoRow" },
            [
              _c(
                "v-col",
                { staticClass: "px-1", attrs: { cols: "4" } },
                [
                  _c("v-text-field", {
                    ref: "promoName",
                    attrs: {
                      label: "Promotion Name",
                      autofocus: !_vm.existingPromo,
                      rules: _vm.promoNameRules,
                      readonly:
                        _vm.readOnlyPromo && !_vm.promoNameEditException,
                      disabled: _vm.tenant === "alliance-retail-group",
                      "background-color": "#fff",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: _vm.promo.name,
                      callback: function($$v) {
                        _vm.$set(_vm.promo, "name", $$v)
                      },
                      expression: "promo.name"
                    }
                  })
                ],
                1
              ),
              _vm._l(_vm.currentFields, function(field, i) {
                return _c(
                  "v-col",
                  {
                    key: i,
                    staticClass: "px-1",
                    attrs: { cols: _vm.currentFields.length > 2 ? null : 2 }
                  },
                  [
                    field.isPercent
                      ? _c("v-text-field", {
                          attrs: {
                            label: field.name,
                            type: "number",
                            min: "0",
                            step: "1",
                            suffix: "%",
                            rules: [_vm.isValidPercent],
                            disabled: _vm.readOnlyPromo,
                            "hide-details": "auto",
                            "background-color": "#fff",
                            dense: "",
                            autocomplete: "off",
                            outlined: ""
                          },
                          model: {
                            value: _vm.promo["" + field.value],
                            callback: function($$v) {
                              _vm.$set(_vm.promo, "" + field.value, $$v)
                            },
                            expression: "promo[`${field.value}`]"
                          }
                        })
                      : _c("v-text-field", {
                          attrs: {
                            label: field.name,
                            type: "number",
                            min: "0",
                            step: ".01",
                            prefix: "$",
                            rules: _vm.getPriceFieldRules(field),
                            disabled:
                              _vm.readOnlyPromo ||
                              (field.value === "variance"
                                ? _vm.isVarianceDisabled
                                : false),
                            error: _vm.showErrorState(field, _vm.promo),
                            "hide-details": "auto",
                            "background-color": "#fff",
                            dense: "",
                            autocomplete: "off",
                            outlined: ""
                          },
                          model: {
                            value: _vm.promo["" + field.value],
                            callback: function($$v) {
                              _vm.$set(_vm.promo, "" + field.value, $$v)
                            },
                            expression: "promo[`${field.value}`]"
                          }
                        })
                  ],
                  1
                )
              }),
              ["pricechopper", "alliance-retail-group"].includes(_vm.tenant)
                ? _c(
                    "v-col",
                    { staticClass: "px-1", attrs: { cols: "2" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Category Manager",
                          items: _vm.categoryManagers,
                          "item-disabled": _vm.isCategoryManagerDisabled,
                          "item-text": "name",
                          "item-value": "id",
                          "item-color": "action",
                          clearable: "",
                          disabled:
                            _vm.enabledInApprovedStatus ||
                            _vm.lockedToBallsQueensManager,
                          "hide-details": "auto",
                          "background-color": "#fff",
                          dense: "",
                          autocomplete: "off",
                          outlined: "",
                          "hide-no-data": ""
                        },
                        model: {
                          value: _vm.promo["category_manager_id"],
                          callback: function($$v) {
                            _vm.$set(_vm.promo, "category_manager_id", $$v)
                          },
                          expression: "promo['category_manager_id']"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }